import { useEffect } from "react";
import { useSession } from "./SessionContext";
import { useNavigate } from "react-router-dom";
import LoadingAnime from "../Common/LoadingAnime";

function AuthGuard({ children }) {
  const { isLoading, isLoggedIn } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isLoggedIn) {
      navigate("/login");
    }
  }, [isLoading, isLoggedIn, navigate]);

  if (isLoading) {
    return <LoadingAnime label="세션 확인 중..." />;
  }

  return <>{children}</>;
}

export default AuthGuard;
